import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import LeftMenuTab from "@/components/LeftMenu/LeftMenuTab.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import dayjs from "dayjs";
import DataExtraServiceDetails from "@/data/ExtraServiceDetails/DataExtraServiceDetails";
import ApiExtraServiceDetails from "@/api/ApiExtraServiceDetails";
let ExtraServiceDetailsList = class ExtraServiceDetailsList extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = [
            {
                to: "/",
                text: this.$t("menu.home"),
            },
            {
                to: "/",
                text: this.$t("menu.cms"),
            },
            {
                to: "/",
                text: "Extra service details",
                disabled: true,
            },
        ];
        this.HasRequest = false;
        this.TableHeaders = DataExtraServiceDetails.TableHeaders;
        this.TableItems = [];
    }
    async GetExtraServiceDetails() {
        try {
            this.HasRequest = true;
            this.TableItems = await ApiExtraServiceDetails.GetExtraServiceDetailsList(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.HasRequest = false;
        }
    }
    created() {
        this.GetExtraServiceDetails();
    }
    formatDate(item) {
        return dayjs.tz(item, "Europe/Rome").format("DD.MM.YYYY");
    }
    async RefreshFromBSS() {
        this.HasRequest = true;
        this.TableItems = [];
        const response = await ApiExtraServiceDetails.ForceRefreshBSSExtraServices(ApiEnter.CurrentSessionUUID);
        if (!response) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error") + response,
                icon: "error",
            });
        }
        await this.GetExtraServiceDetails();
        this.HasRequest = false;
    }
};
ExtraServiceDetailsList = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, LeftMenuTab },
    })
], ExtraServiceDetailsList);
export default ExtraServiceDetailsList;
